import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modify-object-type',
  templateUrl: './modify-object-type.component.html',
  styleUrls: ['./modify-object-type.component.css']
})
export class ModifyObjectTypeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
